export default __webpack_public_path__ + "static/obszar-c556cb2a83060d9189257bf602cb8899.jpg";